import { render, staticRenderFns } from "./BackofficeTotalizer.vue?vue&type=template&id=d2c17392&scoped=true"
import script from "./BackofficeTotalizer.vue?vue&type=script&lang=js"
export * from "./BackofficeTotalizer.vue?vue&type=script&lang=js"
import style0 from "./BackofficeTotalizer.vue?vue&type=style&index=0&id=d2c17392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c17392",
  null
  
)

export default component.exports